import { CompPoints } from '@repo-level/core-front';

export type QuestPoint = { level: number; cp: number; prize: string };

export const questPoints: QuestPoint[] = [
  {
    level: 1,
    cp: 100,
    prize: '10 FS',
  },
  {
    level: 2,
    cp: 250,
    prize: '20 FS',
  },
  {
    level: 3,
    cp: 500,
    prize: '30 FS',
  },
  {
    level: 4,
    cp: 750,
    prize: '50 FS',
  },
  {
    level: 5,
    cp: 1000,
    prize: '75 FS',
  },
  {
    level: 6,
    cp: 2000,
    prize: '100 FS',
  },
  {
    level: 7,
    cp: 3000,
    prize: '€/$10',
  },
  {
    level: 8,
    cp: 4000,
    prize: '€/$20',
  },
  {
    level: 9,
    cp: 5000,
    prize: '€/$50',
  },
  {
    level: 10,
    cp: 7500,
    prize: '€/$70',
  },

  {
    level: 11,
    cp: 10000,
    prize: '€/$100',
  },
  {
    level: 12,
    cp: 16000,
    prize: '€/$160',
  },
  {
    level: 13,
    cp: 20000,
    prize: '€/$200',
  },
  {
    level: 14,
    cp: 50000,
    prize: '€/$500',
  },
  {
    level: 15,
    cp: 100000,
    prize: '€/$1 000',
  },
  {
    level: 16,
    cp: 250000,
    prize: '€/$2 500',
  },
  {
    level: 17,
    cp: 400000,
    prize: '€/$4 000',
  },
  {
    level: 18,
    cp: 800000,
    prize: '€/$7 000',
  },
  {
    level: 19,
    cp: 1500000,
    prize: '€/$15 000',
  },
  {
    level: 20,
    cp: 3000000,
    prize: '€/$30 000',
  },
];

export const detectLevelInfo = (compPoints: CompPoints | undefined) => {
  const points = compPoints?.persistent?.points;

  const currentIndexPoint = questPoints.findIndex(
    ({ cp }, index) =>
      points != null &&
      cp <= points &&
      (questPoints[index + 1] == null || points < questPoints[index + 1].cp)
  );

  const currentLevel = questPoints[currentIndexPoint];
  const nextLevel = questPoints[currentIndexPoint + 1];

  return {
    level: currentLevel?.level || 0,
    prize: currentLevel?.prize,
    nextPrize: nextLevel?.prize || currentLevel?.prize,
    compPoints: points || 0,
    fromCompPoints: currentLevel?.cp || 0,
    toCompPoints: nextLevel?.cp || points || 0,
  };
};
